'use client'
import React from 'react'
import { OrganizationHeader } from '../_components/header'

export default function Page() {
  return <OrganizationHeader />
}
